// /src/componets/SearchModal/Config.jsx

export const Config = {
 // キャッシュバスター用のタイムスタンプを定数で管理
 cacheBuster: "20250623c",
};

// usage
// import { Config } from "./Config";
// console.log(Config.cacheBuster);
